import * as AddToBasket from "@ori-events/add-to-basket";
import { RequestUrl } from "../models";
export default (function (method) {
    switch (method) {
        case AddToBasket.Method.BUY_FOR_MONEY:
            return {
                url: RequestUrl.REQUEST_ADD_TO_BASKET_FOR_MONEY,
                method: AddToBasket.Method.BUY_FOR_MONEY,
            };
        case AddToBasket.Method.BUY_FOR_POINTS:
            return {
                url: RequestUrl.REQUEST_ADD_TO_BASKET_FOR_POINTS_FROM_REWARD_SHOP_PAGE,
                method: AddToBasket.Method.BUY_FOR_POINTS,
            };
        default:
            return {
                url: RequestUrl.REQUEST_LOYALTY_URL,
                method: AddToBasket.Method.BUY_FOR_MONEY,
            };
    }
});
